module.exports = __webpack_public_path__ + "img/Pyrolysis_Eco.2dffd6bb.jpg";